(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-on-amazon"] && !Shopify.designMode) return;
  try {
    class BuyOnAmazon extends HTMLElement {
    connectedCallback() {
      this._onVariantChange = this._onVariantChange.bind(this);
      const script = this.querySelector('script[type="application/json"]');
      this.links = script ? JSON.parse(script.textContent) : {};
      this.blockItem = this.closest('[data-block-type="buy-on-amazon"]');
      this.customCss = this.getAttribute('data-custom-css') || '';
      this.anchor = this.querySelector('a');
      const formId = this.getAttribute('form-id');
      this.form = formId ? document.getElementById(formId) || document.forms[formId] : null;
      this.form?.addEventListener('variant:change', this._onVariantChange);
      this.sync(this.getAttribute('data-variant-id'));
    }

    disconnectedCallback() {
      this.form?.removeEventListener('variant:change', this._onVariantChange);
    }

    _onVariantChange(event) {
      this.sync(event.detail?.variant?.id);
    }

    sync(variantId) {
      const url = variantId != null ? this.links[variantId] || this.links[String(variantId)] : null;

      if (!url) {
        if (this.anchor) {
          this.anchor.hidden = true;
          this.anchor.removeAttribute('href');
        }
        if (this.blockItem) {
          this.blockItem.hidden = true;
          this.blockItem.removeAttribute('style');
        }
        return;
      }

      if (this.anchor) {
        this.anchor.hidden = false;
        this.anchor.href = url;
      }
      if (this.blockItem) {
        this.blockItem.hidden = false;
        if (this.customCss) {
          this.blockItem.setAttribute('style', this.customCss);
        } else {
          this.blockItem.removeAttribute('style');
        }
      }
    }
  }

  if (!window.customElements.get('buy-on-amazon')) {
    window.customElements.define('buy-on-amazon', BuyOnAmazon);
  }
  } catch(e) { console.error(e); }
})();

})();
